// extracted by mini-css-extract-plugin
export var button = "title-module--button--2e582";
export var cafeFormIntro = "title-module--cafe-form-intro--f1464";
export var highlight = "title-module--highlight--f8db4";
export var redButton = "title-module--red-button--21924";
export var redTransparentButton = "title-module--red-transparent-button--50bc6";
export var spanLayout = "title-module--span-layout--d40f7";
export var spanLayoutItalic = "title-module--span-layoutItalic--326a3";
export var transparentButton = "title-module--transparent-button--67850";